import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import { router } from './router'
import './style.css'
import { useAuthStore } from './stores/auth'
import { useTheme } from './composables/useTheme'

// Sync the theme ref with the class the no-flash script already applied.
useTheme().init()

const app = createApp(App)
const pinia = createPinia()

// Monitoreo de errores en producción. Sin DSN no se inicializa (desarrollo).
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: `cafe-ventas-frontend@${import.meta.env.VITE_APP_VERSION ?? 'dev'}`,
    sendDefaultPii: false,
    tracesSampleRate: 0,
  })
}

app.use(pinia)
app.use(router)
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
})

// Try to restore the session before mounting so the router guards see the right state.
const auth = useAuthStore()
auth.bootstrap().finally(() => {
  app.mount('#app')
})
